import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { TebGelirService } from '../ctl-teb-gelir.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: TebGelirService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([
                'Kod',
                'Ad',
                'Donem',
                'EkoGelirKod',
            ]);


            const filterArr = [];
            if(this.service.period) filterArr.push(['Donem', '=', this.service.period]);
            filterArr.push(['EkoGelirKod.Length', '>=', 6]);
            dataSource.filter(filterArr)
            return dataSource;
    }

}
